import { render, staticRenderFns } from "./OpEvaluateWork.vue?vue&type=template&id=387bd4e7&scoped=true"
import script from "./OpEvaluateWork.vue?vue&type=script&lang=js"
export * from "./OpEvaluateWork.vue?vue&type=script&lang=js"
import style0 from "./OpEvaluateWork.vue?vue&type=style&index=0&id=387bd4e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387bd4e7",
  null
  
)

export default component.exports